module.exports = __webpack_public_path__ + "static/media/edit.4da54d04.svg";